<template>

  <v-container fluid>

    <v-row class="ml-5" align="center" dense>
      <v-col md="3" sm="12" xs="12" >
        <label class="menunamestyle ml-1">{{this.$session.get("MENUNAME")}}</label>          
      </v-col>
      <v-spacer/>
      <v-col md="3" sm="12" xs="12" >
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      <v-col md="3" sm="12" xs="12" >
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
    </v-row>

    <v-row>

      <v-col md="3" sm="12" xs="12" align="center">

        <v-row dense no-gutters justify="end">
          <v-btn class="search_btn mx-1" elevation="0" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
          <v-btn class="search_btn" elevation="0" outlined large @click="newlayout">{{$t('emaildesign_label1')}}</v-btn>
        </v-row>
        
        <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="9999"
            :no-data-text="nodatament"
            class="datatablestyle mt-2"
            item-key="name"
            hide-default-footer
            :loading="loading"
            >

            <template v-slot:header.LAYOUT_NAME>
              <label class="cheader_normal" >{{$t("emaildesign_col1")}}</label>
            </template>
            <template v-slot:header.detail>
              <label class="cheader_normal" >{{$t("emaildesign_col2")}}</label>
            </template>

          <template v-slot:item.detail="{item}">
              <v-icon class="mr-2" small @click="loaddetail(item)">mdi-pencil</v-icon>
          </template>
        </v-data-table>

      </v-col>

      <v-col style="background:white; border-style:solid; border-width:0px 2px 0px 0px;border-color:#f2f2f2" cols="12" md="6" sm="12" xs="12">

        <v-row class="mt-5" justify="center" dense no-gutters>
          
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="addcomponent" v-bind="attrs" v-on="on"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
              </template>
              <span>{{$t("common_insert")}}</span>
            </v-tooltip>

            <!-- 
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="centeralign" v-bind="attrs" v-on="on"><v-icon>mdi-align-horizontal-center</v-icon></v-btn>
              </template>
              <span>{{$t('design_label5')}}</span>
            </v-tooltip>
            
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="fullsize" v-bind="attrs" v-on="on"><v-icon>mdi-arrow-split-vertical</v-icon></v-btn>
              </template>
              <span>{{$t('design_label6')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="getfront" v-bind="attrs" v-on="on"><v-icon>mdi-arrange-bring-forward</v-icon></v-btn>
              </template>
              <span>{{$t('design_label7')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="pushback" v-bind="attrs" v-on="on"><v-icon>mdi-arrange-send-backward</v-icon></v-btn>
              </template>
              <span>{{$t('design_label8')}}</span>
            </v-tooltip>
            -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="deletedesign" v-bind="attrs" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
              </template>
              <span>{{$t('design_label10')}}</span>
            </v-tooltip>
          
        </v-row>

        <v-row justify="center" dense no-gutters>
          <div id="edit_div_line2" :style="'margin-top:'+(DISPLAY_HEIGHT+50+6)+'px;'">
          </div>
          <div id="edit_div_line" :style="'margin-left:20px;width:'+(DISPLAY_WIDTH+6)+'px;height:'+(DISPLAY_HEIGHT+6)+'px;backgroundColor:#808080;overflow:auto;position:absolute;border:solid 3px #4e6ef7;'">
            <div id="edit_div" :style="'width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#ffffff;position:absolute;'">
            </div>
          </div>
        </v-row>    
      </v-col>
      
      <v-col style="background:white" v-if="PARENT_ITEM.ADMIN_IDX != null" cols="12" md="3" sm="12" xs="12">

        <v-row class="ml-5 mr-5" dense>
            <v-text-field outlined v-model="PARENT_ITEM.LAYOUT_NAME" :label="$t('emaildesign_label2')"
              hide-details dense
              />
        </v-row>
        
        <v-row dense class="ml-5 mr-5 mt-5">
          <v-col class="ma-0 pa-0">
            <v-file-input outlined dense accept="image/*" :label="$t('emaildesign_label3')" v-model="uploadFile" @change="changefile"/>
          </v-col>
          <template v-if="SELECT_ITEM[0].LOCALIMG != null ">
            <v-btn class="ml-2 search_btn" style="height:38px !important" @click="uploadimage">{{$t("common_save")}}</v-btn>
          </template>
        </v-row>

        <v-row dense class="ml-5 mr-5">
          <v-col class="ma-0 pa-0">
            <v-textarea outlined dense height="70" no-resize ref="ref_textvalue" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :value="SELECT_ITEM[0].TEXTVALUE" @change="changevalue" :label="$t('emaildesign_label4')" @keydown.enter="changevalue"></v-textarea>
          </v-col>
          <v-btn class="ml-2 search_btn" style="height:38px !important" @click="changevalue">{{$t('design_label21')}}</v-btn>          
        </v-row>
        
        <v-row dense class="ml-5 mr-5" justify="center">
          <v-btn class="search_btn_freesize" width="90%" outlined large @click="savedesign">{{$t('emaildesign_label5')}}</v-btn> 
        </v-row>

      </v-col>

    </v-row>

  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import DRBackground from '../dragndrop/DRBackground.js'
// eslint-disable-next-line no-unused-vars
import DRComponent from '../dragndrop/DRComponent.js'
// eslint-disable-next-line no-unused-vars
import DRModel from '../dragndrop/DRModel.js'
export default {

    data: () => ({

        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',
        grade : 0,

        nodatament : "No Data",       
        items: [],
        loading : false,    //로딩 표시

        headers: [
          {text: '템플릿명', align: 'center', sortable: false, value: 'LAYOUT_NAME'},
          {text: '디자인', align: 'center', sortable: false, value: 'detail'},
        ],

      //파일 업로드
        uploadFile : null
      , imgPreview : null
      
      , drback: null
      , SELECT_ITEM: [{}]  //서브 클래스에 참조타입으로 넘길려면 배열로 넘겨야 참조가 됨.

      , DISPLAY_WIDTH:750
      , DISPLAY_HEIGHT:1000
      , PARENT_ITEM: {},

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");


      const edit_div  = document.getElementById("edit_div");
      const bg = new DRModel();
      bg.LAYOUT_WIDTH   = 0;
      bg.LAYOUT_HEIGHT  = 0;
      bg.LAYOUT_POSX    = 0;
      bg.LAYOUT_POSY    = 0;
      bg.ISBG           = 1;  //bg
      bg.COMPONENT_TYPE = 0; 
      bg.BGTYPE = 0;
      bg.BGCOLOR = "FFFFFFFF";
      this.drback  = new DRBackground(bg, this.SELECT_ITEM, this, true);
      edit_div.appendChild(this.drback.back_div);
      this.SELECT_ITEM.splice(0,1,bg);

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인 해야해
        this.$router.push("Login");
        return;
      }
      
    },

    create(){

    },

    computed:{
      //canvas의 사이즈가 변경되면 draw background도 사이즈 변경
      edit_div_style: function(){
        //console.log("computed...");
        return "width:"+this.DISPLAY_WIDTH+"px;height:"+this.DISPLAY_HEIGHT+"px;backgroundColor:#00ff0080;overflow:hidden;position:absolute;";
        //return "width:1750px;height:"+this.canvas_height+"px;backgroundColor:#80000080;overflow:hidden;position:absolute;";
      },
    },

    methods: {
      
      //검색
      search_run(){
        this.loadpage();
      },

      changevalue(){
        let inputEl = this.$refs.ref_textvalue.$el.querySelector('textarea');
        var ev = inputEl.value;
        this.SELECT_ITEM[0].TEXTVALUE = ev;
        this.drback.updateComponent();
      },

      async newlayout(){

        //해당 값이 들어가야 edit_div가 보여진다.
        this.PARENT_ITEM = {};
        this.PARENT_ITEM.ADMIN_IDX   = this.$session.get("ADMIN_IDX");
        this.PARENT_ITEM.LAYOUT_NAME = this.$t('emaildesign_msg1');

        this.DISPLAY_WIDTH  = 750;
        this.DISPLAY_HEIGHT = 1000;

        setTimeout(() => {  
          const edit_div = document.getElementById("edit_div");
          while ( edit_div.hasChildNodes() ) {
            edit_div.removeChild( edit_div.firstChild ); 
          }

          const bg = new DRModel();
          bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH;
          bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
          bg.LAYOUT_POSX    = 0;
          bg.LAYOUT_POSY    = 0;
          bg.ISBG           = 1;  //bg
          bg.COMPONENT_TYPE = 0; 
          bg.BGTYPE         = 0;
          bg.BGCOLOR        = "00FF00FF";
          this.drback       = new DRBackground(bg, this.SELECT_ITEM, this, true);
          edit_div.appendChild(this.drback.back_div);

        }, 1000);

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },

      loaddetail(item){
          
          this.PARENT_ITEM = item;
          this.$http.post(this.$host+'/api/EmailDesignDetail',
            {
                ADMIN_IDX : this.PARENT_ITEM.ADMIN_IDX
              , COM_IDX : this.PARENT_ITEM.COM_IDX
              , EVENT_IDX : this.PARENT_ITEM.EVENT_IDX
              , EMAIL_IDX : this.PARENT_ITEM.EMAIL_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              //초기화
              this.drback.clearBackground();
              

              var tempobj         = JSON.parse(JSON.stringify(result.data.resultData)); //파싱
              this.SELECT_DESIGN  = tempobj[0];
              this.DISPLAY_WIDTH  = this.SELECT_DESIGN.COMPONENT_WIDTH;
              this.DISPLAY_HEIGHT = this.SELECT_DESIGN.COMPONENT_HEIGHT;

              //컴포넌트 생성
              this.createComponent(this.drback,  this.SELECT_DESIGN.COMPONENT.data);


            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              //BG초기화
              this.drback.clearBackground();
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              //BG초기화
              //console.log("error : " + error);
          });

      },



      createComponent(bg, list){

        //컴포넌트 생성
        list.forEach(element => {
          
          const model         = new DRModel();
          model.ADMIN_IDX     = element.ADMIN_IDX;
          model.EVENT_IDX     = element.EVENT_IDX;
          model.STEP_IDX      = element.STEP_IDX;
          model.IMG           = element.IMG;
          model.LOCALIMG      = null;
          model.ISBG          = element.ISBG;
          model.BGTYPE        = element.BGTYPE;
          model.BGCOLOR       = element.BGCOLOR;
          model.TEXTCOLOR     = element.TEXTCOLOR;
          model.TEXTSIZE      = element.TEXTSIZE;
          model.TEXTFONT      = element.TEXTFONT;
          model.TEXTVALUE     = element.TEXTVALUE;
          model.TEXTALIGN     = element.TEXTALIGN;
          model.TEXTMATCH     = element.TEXTMATCH;
          model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
          model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
          model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
          model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);

          model.TEMP_POSX   = model.LAYOUT_POSX;
          model.TEMP_POSY   = model.LAYOUT_POSY;
          model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
          model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

          model.ZINDEX        = element.ZINDEX;
          model.COMPONENT_TYPE = element.COMPONENT_TYPE;

          //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
          //console.log("component type : " + model.ISBG);
          if(element.ISBG == undefined || element.ISBG == null || element.ISBG == 1){
            bg.updateBackground(model);
          }else{
            //컴포넌트 객체 생성.
            const component = new DRComponent(model, this.MATCHTYPELIST, false);
            bg.addComponent(component, false);
          }

        });

      },      

      addcomponent(){
        const cm = new DRModel();
        cm.COMPONENT_TYPE = 1;
        cm.BGCOLOR = "FF000080";
        cm.TEXTCOLOR = "FFFFFFFF";
        cm.TEXTSIZE  = 12;
        cm.TEXTVALUE = "";
        const cp = new DRComponent(cm, [], false);
        this.drback.addComponent(cp, true);
        cp.setMatchTextValue();
      },

      fullsize(){
        this.drback.fullsize();
      },

      centeralign(){
        this.drback.centeralign();
      },

      getfront(){
        this.drback.getfront();
      },

      pushback(){
        this.drback.pushback();
      },

      deletedesign(){
        this.drback.removeComponent();
      },

      getImageSize(item){
        //const pxTomm = this.pxTomm;
        return new Promise((resolve, reject)=>{
          var tempimg = new Image();
          tempimg.onload = () =>resolve(tempimg);
          tempimg.onerror = reject;
          tempimg.src = item;
        })
      },

      async changefile(){

        var file = this.uploadFile;
        if (file && file.type.match(/^image\/(png|jpeg)$/)) {

          this.imgPreview = window.URL.createObjectURL(file) //로컬 파일 경로를 가지고 이미지를 보여준다.

          //이미지 사이즈 계산
          var temp = await this.getImageSize(this.imgPreview);
          //console.log("image size : " + temp.width + " / " + temp.height);
          if(temp.width > 800 || temp.width < 600){
            this.$alert(this.$t('emaildesign_msg2'));
            return;
          }
          
          this.DISPLAY_WIDTH  = temp.width;
          this.DISPLAY_HEIGHT = temp.height;
          this.drback.clearBackground();
          this.drback.setLayoutChange(this.DISPLAY_WIDTH, this.DISPLAY_HEIGHT);
          this.drback.updateComponent();

          const bg = new DRModel();
          bg.LAYOUT_WIDTH   = temp.width;
          bg.LAYOUT_HEIGHT  = temp.height;
          bg.LAYOUT_POSX    = 0;
          bg.LAYOUT_POSY    = 0;
          bg.ISBG           = 1;  //bg
          bg.IMG            = this.imgPreview;
          bg.LOCALIMG       = file; //blob 타입
          bg.COMPONENT_TYPE = 0;
          bg.BGTYPE         = 1;
          bg.BGCOLOR        = "FF0000FF";
          
          this.SELECT_ITEM.splice(0,1,bg);
          this.drback.updateBackground(bg);
          //var img = document.getElementById("img");
          //console.log("img3 : " + JSON.stringify(img.getBoundingClientRect()));
          //console.log("img4 : " + img.width);

          //this.SELECT_ITEM[0].IMG       = temp;
          //this.SELECT_ITEM[0].LOCALIMG  = file; //blob 타입

          //갱신
          
        }
      },



      async changefile2(){

        var file = this.uploadFile;
        if (file && file.type.match(/^image\/(png|jpeg)$/)) {

          this.imgPreview = window.URL.createObjectURL(file) //로컬 파일 경로를 가지고 이미지를 보여준다.
          
          //이미지 사이즈 계산
          var temp = await this.getImageSize(this.imgPreview);
          //console.log("image size : " + temp.width + " / " + temp.height);
          if(temp.width > 800 || temp.width < 700){
            this.$alert(this.$t('emaildesign_msg3'));
            return;
          }

          this.SELECT_ITEM[0].IMG       = this.imgPreview;
          this.SELECT_ITEM[0].LOCALIMG  = file; //blob 타입

          
          this.DISPLAY_WIDTH  = temp.width;
          this.DISPLAY_HEIGHT = temp.height;
          
          const edit_div  = document.getElementById("edit_div");
          const bg = new DRModel();
          bg.LAYOUT_WIDTH   = temp.width;
          bg.LAYOUT_HEIGHT  = temp.height;
          bg.LAYOUT_POSX    = 0;
          bg.LAYOUT_POSY    = 0;
          bg.ISBG           = 1;  //bg
          bg.COMPONENT_TYPE = 0;
          bg.BGTYPE         = 0;
          bg.BGCOLOR        = "FFFFFFFF";
          this.drback       = new DRBackground(bg, this.SELECT_ITEM, this, true);
          edit_div.appendChild(this.drback.back_div);

          this.drback.updateBackground(this.SELECT_ITEM[0]);


          this.SELECT_ITEM.splice(0,1,bg);
          //var img = document.getElementById("img");
          //console.log("img3 : " + JSON.stringify(img.getBoundingClientRect()));
          //console.log("img4 : " + img.width);

          //this.SELECT_ITEM[0].IMG       = temp;
          //this.SELECT_ITEM[0].LOCALIMG  = file; //blob 타입

          //갱신
          
        }
      },

      uploadimage(){

        if(this.SELECT_ITEM[0].LOCALIMG == null){
          this.$alert(this.$t('design_msg7'));
          return;
        }

        const formData = new FormData();
        formData.append("FOLDER", this.SEARCH_COM_IDX+"/emaildesign");
        formData.append("customfile", this.SELECT_ITEM[0].LOCALIMG);
        this.$http.post(this.$host+'/api/UploadImage', formData, {
          headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
        })
        .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            //성공
            const fileurl = result.data.resultData[0].fileurl;
            
            //변경
            this.SELECT_ITEM[0].IMG       = fileurl;
            this.SELECT_ITEM[0].LOCALIMG  = null;

            //갱신
            if(this.SELECT_ITEM[0].ISBG == 1){
              this.drback.updateBackground(this.SELECT_ITEM[0]);
            }
            this.uploadFile = null;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }

        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
        });

      },

      //DRBackground가 호출함. true면 앞면 false면 뒷면
      selectface(flag){
        console.log("select face : " + flag);
      },
      colorupdate(){
        //이미지
        this.uploadFile = this.SELECT_ITEM[0].LOCALIMG;
        this.$forceUpdate();
      },

      loadpage(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.loading = true;
        this.$http.post(this.$host+'/api/EmailDesignList',
          {
              ADMIN_IDX:  this.$session.get("ADMIN_IDX")
            , COM_IDX:    this.SEARCH_COM_IDX
            , EVENT_IDX : this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          this.loading = false;
          if(result.data.resultCode == 0){
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            const list = result.data.resultData;
            this.items.splice(0, this.items.length);   //데이터 초기화
            list.forEach(element => {
                this.items.push(element); 
            });
            this.loading = false;
            
          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.loading = false;
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });

      },      

      savedesign(){

        if(this.drback == null || this.drback == undefined || this.drback.back_div == null || this.drback.back_div == undefined){
          this.$alert(this.$t('emaildesign_msg4'));
          return;
        }

        //로컬이미지가 있다면 저장 불가.
        var flag = true;
        if(this.drback.back_div.model.LOCALIMG != null){
          flag = false;
        }
        if(!flag){
          this.$alert(this.$t('design_msg2'));
          return;
        }
        for(var j=0;j<this.drback.back_div.component_list.length;j++){
          if(this.drback.back_div.component_list[j].temp_div.model.LOCALIMG != null){
            flag = false;
            break;
          }
        }
        if(!flag){
          this.$alert(this.$t('design_msg2'));
          return;
        }

        if(this.PARENT_ITEM.LAYOUT_NAME == null || this.PARENT_ITEM.LAYOUT_NAME == undefined || this.PARENT_ITEM.LAYOUT_NAME.length < 1){
          this.$alert(this.$t('emaildesign_msg5'));
          return;
        }

        //뉴라인 특수문자 컨버트 처리
        this.drback.back_div.component_list.forEach(cm=>{
            //if(cm.model.COMPONENT_TYPE == 1 && cm.model.TEXTMATCH == "INPUT"){
            if(cm.model.COMPONENT_TYPE == 1){
              //console.log(cm.model.TEXTVALUE.replaceAll("\n", "\\n"));
              cm.model.TEXTVALUE = cm.model.TEXTVALUE.replaceAll("\n", "\\n");
            }
        });
        
        //객체를 JSON으로 변환하는거 같은데 요고 바꾸자
        var temp_obj  = JSON.parse('{"data":[]}');
        
        //배경 컴포넌트 넣어주고
        temp_obj["data"].push(this.drback.back_div.model);
        this.drback.back_div.component_list.forEach(cm=>{
          temp_obj["data"].push(cm.model);
        });
        
        
        if(this.PARENT_ITEM.EVENT_IDX == undefined){

          //신규
          this.$http.post(this.$host+'/api/EmailDesignInsert',
            {
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , COM_IDX: this.SEARCH_COM_IDX
              , LAYOUT_NAME: escape(this.PARENT_ITEM.LAYOUT_NAME)
              , COMPONENT_WIDTH: this.DISPLAY_WIDTH
              , COMPONENT_HEIGHT: this.DISPLAY_HEIGHT
              , COMPONENT: escape(JSON.stringify(temp_obj).replaceAll('\n','\\n'))
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              //this.SELECT_DESIGN.COMPONENT   = temp_obj;
              //this.SELECT_DESIGN.COMPONENT2  = temp_obj2;
              this.$alert(this.$t('design_msg3'));
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
          });

        }else{
          //업데이트
          this.$http.post(this.$host+'/api/EmailDesignUpdate',
            {
                ADMIN_IDX: this.PARENT_ITEM.ADMIN_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , COM_IDX: this.SEARCH_COM_IDX
              , EMAIL_IDX: this.PARENT_ITEM.EMAIL_IDX
              , LAYOUT_NAME: escape(this.PARENT_ITEM.LAYOUT_NAME)
              , COMPONENT_WIDTH: this.DISPLAY_WIDTH
              , COMPONENT_HEIGHT: this.DISPLAY_HEIGHT
              , COMPONENT: escape(JSON.stringify(temp_obj))
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.SELECT_DESIGN.COMPONENT   = temp_obj;
              this.$alert(this.$t('design_msg3'));

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
          });

        }
          

      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.$session.set("OPTION_IDX", null);
        this.$session.set("OPTION_NAME", "");
        this.drback.clearBackground();
        this.loadpage();
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME",'');
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME",'');
        }
        this.drback.clearBackground();
        this.loadpage();
      },    

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME", "");
          this.drback.clearBackground();
          this.loadpage();
          
      },      


    },

  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>